import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import The126House from "./pages/The126House";
import AboutNF from "./pages/AboutNF";
import Privacy from "./pages/Privacy";

function App() {
  return (
    <div className="App min-h-screen bg-[#3d4a3f]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<The126House />} />
          <Route path="/about" element={<AboutNF />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
